
import self from '../../assets/img/9.jpeg'
export const styles = {
    chatWithMeButton: {
        cursor: 'pointer',
        boxShadow: '0px 0px 16px 6px rgba(0, 0, 0, 0.33)',
        // Border
        borderRadius: '50%',
        // Background 
        backgroundImage:`url(${self})`,
        // backgroundRepeat: 'no-repeat',
        // backgroundPosition: 'center',
        backgroundSize: '84px',
        // Size
        width: '84px',
        height: '84px',
    },
    avatarHello: { 
        // Position
        position: 'absolute', 
        left: 'calc(-100% - 44px - 28px)', /*This should change where the popup text comes in at */
        top: 'calc(50% - 24px)', 
        // Layering
        zIndex: '10000',
        // boxShadow: '0px 0px 16px 6px rgba(0, 0, 0, 0.33)',
        // Border
        padding: '12px 12px 12px 16px',
        // borderRadius: '24px', 
        // Color
        backgroundColor: '#f9f0ff',
        color: 'black',
    },
    supportWindow: {
        // Position
        position: 'fixed',
        bottom: '16px',
        right: '24px',
        // Size
        width: '420px',
        height: '530px',
        maxWidth: 'calc(100% - 48px)',
        maxHeight: 'calc(100% - 48px)',
        backgroundColor: 'white',
        // Border
        borderRadius: '12px',
        border: `2px solid #7a39e0`,
        overflow: 'hidden',
        // Shadow
        boxShadow: '0px 0px 16px 6px rgba(0, 0, 0, 0.33)',
    },
    emailFormWindow: { 
        width: '100%',  
        overflow: 'hidden',
        transition: "all 0.5s ease",
        WebkitTransition: "all 0.5s ease",
        MozTransition: "all 0.5s ease",
    },
    stripe: {
        position: 'relative',
        top: '-45px',
        width: '100%',
        height: '308px',
        backgroundColor: '#7a39e0',
        transform: 'skewY(-12deg)',
    },
    topText: { 
        position: 'relative',
        width: '100%', 
        top: '15%', 
        color: 'greysmoke', 
        fontSize: '20px',
        borderBottom:'3px solid red',
        fontWeight: '600',
        lineHeight:'.21in',
        letterSpacing:'.03in'
    },
    emailInput: { 
        width: '66%',
        textAlign: 'center',
        outline: 'none',
        padding: '10px',
        borderRadius: '9px',
        marginTop:'55px',
        display:'grid',
        alignItems:'center',
        marginLeft:'308px',
        maxWidth:'400px',
        overflow:'hidden',
        textAlign:'left',
        backgroundColor:'whitesmoke',
        boxShadow:'3px 3px 3px 3px grey',
        color:'purple',
        borderBottom:'2px solid red',
        border: '2px solid #7a39e0',
    },
    bottomText: { 
        position: 'absolute', 
        width: '100%', 
        top: '60%', 
        color: '#7a39e0', 
        marginTop:'30px',
       borderBottom:'3px solid red',
        fontSize: '18px', 
        fontWeight: '600' 
    },
    loadingDiv: { 
        position: 'absolute', 
        height: '99.9%', 
        width: '99.9%', 
        textAlign: 'center', 
        backgroundColor: 'orangered',
        opacity:'23%'
    },
    loadingIcon: { 
        color: '#7a39e0', 
        position: 'absolute', 
        top: 'calc(50% - 51px)', 
        left: 'calc(50% - 51px)',  
        fontWeight: '600',
        color:'yellow'
    },
    chatEngineWindow: {
        width: '100%',  
        backgroundColor: '#fff',
    }
}